module.exports = __webpack_public_path__ + "img/Bone_Hourglass.79129050.png";